export function SimpleSpinner() {
  return (
    <div className="pending-spinner simple">
      <div className="ps-mid">
        <div className="spinner" />
      </div>
    </div>
  )
}
